const AddClassDrawerSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse mt-4">
      {/* Class Name Input */}
      <div className="flex flex-col gap-2">
        <div className="w-32 h-4 bg-neutral-200 rounded " />
        <div className="w-full h-10 bg-neutral-200 rounded-md " />
      </div>

      {/* Assign Teacher Select */}
      <div className="flex flex-col gap-2">
        <div className="w-40 h-4 bg-neutral-200 rounded " />
        <div className="w-full h-10 bg-neutral-200 rounded-md " />
      </div>

      {/* Class Teacher Select */}
      <div className="flex flex-col gap-2">
        <div className="w-40 h-4 bg-neutral-200 rounded " />
        <div className="w-full h-10 bg-neutral-200 rounded-md " />
      </div>
    </div>
  );
};

export default AddClassDrawerSkeleton;
